import { render, staticRenderFns } from "./ModelItem.vue?vue&type=template&id=de0d1998&"
import script from "./ModelItem.vue?vue&type=script&lang=js&"
export * from "./ModelItem.vue?vue&type=script&lang=js&"
import style0 from "./ModelItem.vue?vue&type=style&index=0&id=de0d1998&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports